export default "__VITE_ASSET__D3vu3p97__"